import { render } from "./CardStatusOrder.vue?vue&type=template&id=b979fe74&scoped=true"
import script from "./CardStatusOrder.vue?vue&type=script&lang=js"
export * from "./CardStatusOrder.vue?vue&type=script&lang=js"

import "./CardStatusOrder.vue?vue&type=style&index=0&id=b979fe74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b979fe74"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
